// extracted by mini-css-extract-plugin
module.exports = {"th-td":"CertificationsTable_th-td__1copq"};